<template>
  <div class="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200">
    <div class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-space-y-0 tw-pb-2 tw-p-6">
      <div class="tw-flex tw-items-center tw-gap-2">
        <FileText class="tw-w-5 tw-h-5 tw-text-gray-600" />
        <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900">
          {{ t('customer_management.titles.legals') }}
        </h3>
      </div>
    </div>

    <div class="tw-px-6 tw-pb-6">
      <div class="tw-space-y-6">
        <div>
          <label class="tw-text-sm tw-text-gray-600">
            {{ t('customer_management.titles.legal_notes') }}
          </label>
          <div class="tw-mt-2 tw-p-4 tw-bg-gray-50 tw-rounded-lg">
            <p
              class="tw-text-sm tw-whitespace-pre-wrap"
              :class="
                customer.legal_notes && customer.legal_notes.trim()
                  ? 'tw-text-gray-900'
                  : 'tw-text-gray-500 tw-italic'
              "
            >
              {{ formatLegalText(customer.legal_notes) }}
            </p>
          </div>
        </div>
        <div>
          <label class="tw-text-sm tw-text-gray-600">
            {{ t('customer_management.titles.terms_and_conditions') }}
          </label>
          <div class="tw-mt-2 tw-p-4 tw-bg-gray-50 tw-rounded-lg">
            <p
              class="tw-text-sm tw-whitespace-pre-wrap"
              :class="
                customer.terms_and_conditions && customer.terms_and_conditions.trim()
                  ? 'tw-text-gray-900'
                  : 'tw-text-gray-500 tw-italic'
              "
            >
              {{ formatLegalText(customer.terms_and_conditions) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FileText } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'CustomerLegals',
});

interface Customer {
  legal_notes?: string;
  terms_and_conditions?: string;
}

interface Props {
  customer: Customer;
}

defineProps<Props>();
const { t } = useI18n();

const formatLegalText = (text?: string): string => {
  if (!text || text.trim() === '' || text.trim() === 'null' || text.trim() === 'undefined') {
    return '--';
  }
  return text.trim();
};
</script>
